import { Exception } from "./exception.js";
import { __ } from "../utils/i18n.js";
class RealCommerceError extends Exception {
    get isBackendDown() {
        // If the backend is down, it never receives a status code via HTTP
        return this.status === undefined;
    }
    get codes() {
        return this.errors.map(({ code })=>code);
    }
    constructor(error){
        super(RealCommerceError.generateMessageFromError(error), "RealCommerceError");
        this.errors = error.responseJSON || [];
        this.original = error;
        this.status = error.status;
    }
    static generateMessageFromError(e) {
        if (e.responseJSON) {
            return e.responseJSON.map(({ message })=>message).join(" ");
        }
        return e.status === 401 ? __("Your session expired. Please login again.") : __("Something went wrong on our end. Please contact our support team!");
    }
    hasErrorCode(check) {
        if (Array.isArray(check)) {
            return this.codes.some((code)=>check.indexOf(code) > -1);
        } else {
            return this.codes.indexOf(check) > -1;
        }
    }
}
export { RealCommerceError };
